// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__87aeB","input":"Input_input__esWvs","icon":"Input_icon__l5zvU","wrapper__icon":"Input_wrapper__icon__MS4s5"};